import React, { useEffect, useState, useCallback } from 'react';
// import Cookies from 'js-cookie';
import { utcToZonedTime, format } from 'date-fns-tz';

export const StreakNumber = ({ correctGuess }) => {
  const [streak, setStreak] = useState(0);

  const updateStreak = useCallback(() => {
    let riddleStats = localStorage.getItem('riddleStats');
    riddleStats = riddleStats ? JSON.parse(riddleStats) : {};

    const now = new Date();
    const newYorkTime = utcToZonedTime(now, 'America/New_York');
    const newYorkDate = format(newYorkTime, 'yyyy-MM-dd');

    const sortedDates = Object.keys(riddleStats).sort((a, b) => new Date(b) - new Date(a));

    if (isMoreThanADayApart(newYorkDate, sortedDates[0])) {
      setStreak(0);
    } else {
      let streakCount = 0;
      for (let i = 0; i < sortedDates.length; i++) {
        const date = sortedDates[i];
        const riddleStat = riddleStats[date];
        if (!riddleStat.solved || (i > 0 && isMoreThanADayApart(sortedDates[i - 1], date))) {
          break;
        }
        streakCount++;
      }
      setStreak(streakCount);
    }
  }, []);

  useEffect(() => {
    updateStreak();
  }, [updateStreak]);


  const isMoreThanADayApart = (date1, date2) => {
    const parsedDate1 = new Date(date1);
    const parsedDate2 = new Date(date2);
    const difference = Math.abs(parsedDate1 - parsedDate2);
    const differenceInDays = difference / (1000 * 60 * 60 * 24);
    return differenceInDays > 1;
  };

  return streak;
};


export const DailyStreak = ({ correctGuess }) => {
  // const streak = StreakNumber({ correctGuess });  // Use StreakNumber component

  return (
    <div className="daily-streak">
      🔥 <StreakNumber correctGuess={correctGuess} />
    </div>
  );
};

export const MaxStreakNumber = () => {

  const [maxStreak, setMaxStreak] = useState(0);

  const updateMaxStreak = useCallback(() => {
    let riddleStats = localStorage.getItem('riddleStats');
    riddleStats = riddleStats ? JSON.parse(riddleStats) : {};

    const sortedDates = Object.keys(riddleStats).sort((a, b) => new Date(a) - new Date(b));

    let currentStreakCount = 0;
    let maxStreakCount = 0;

    for (let i = 0; i < sortedDates.length; i++) {
      const date = sortedDates[i];
      const riddleStat = riddleStats[date];

      if (riddleStat.solved) {
        currentStreakCount++;
        if (currentStreakCount > maxStreakCount) {
          maxStreakCount = currentStreakCount;
        }
      } else {
        currentStreakCount = 0;
      }

      if (i < sortedDates.length - 1) {
        const nextDate = sortedDates[i + 1];
        if (isMoreThanADayApart(date, nextDate)) {
          currentStreakCount = 0;
        }
      }
    }

    setMaxStreak(maxStreakCount);
  }, []);

  useEffect(() => {
    updateMaxStreak();
  }, [updateMaxStreak]);
  

  const isMoreThanADayApart = (date1, date2) => {
    const parsedDate1 = new Date(date1);
    const parsedDate2 = new Date(date2);
    const difference = Math.abs(parsedDate1 - parsedDate2);
    const differenceInDays = difference / (1000 * 60 * 60 * 24);
    return differenceInDays > 1;
  };

  return maxStreak;
};
